var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120mm",
    height: "20mm",
    viewBox: "0 0 120 20",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 424.49179,
    y: 224.43037,
    width: 252.33679,
    height: 166.25929,
    id: "rect417"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-4.1444942,-53.735931)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path15413",
    style: {
      fill: "#aa9664",
      stroke: "#060606",
      strokeWidth: 0.264583
    },
    cx: -93.242149,
    cy: 61.769245,
    r: 0.048717778
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path6877",
    style: {
      fill: "#d52941",
      stroke: "none",
      strokeWidth: 0.264583
    },
    cx: 22.046715,
    cy: 73.627708,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path6879",
    style: {
      fill: "#d52941",
      stroke: "none",
      strokeWidth: 0.264583
    },
    cx: 80.283325,
    cy: 76.747528,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path6881",
    style: {
      fill: "#d52941",
      stroke: "none",
      strokeWidth: 0.264583
    },
    cx: 19.550861,
    cy: 77.579475,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path6883",
    style: {
      fill: "#d52941",
      stroke: "none",
      strokeWidth: 0.264583
    },
    cx: 78.203445,
    cy: 74.043686,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path6895",
    style: {
      fill: "#d52941",
      stroke: "none",
      strokeWidth: 0.264583
    },
    cx: 87.562897,
    cy: 124.16876,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path6897",
    style: {
      fill: "#d52941",
      stroke: "none",
      strokeWidth: 0.264583
    },
    cx: 65.724167,
    cy: 121.04895,
    r: 0
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9ddaf",
      fillOpacity: 1,
      stroke: "#d52941",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 16.535037,59.588526 H 76.227554",
    id: "path6899"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "scale(0.26458333)",
    id: "text415",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 56,
      fontFamily: "'Cooper Hewitt'",
      InkscapeFontSpecification: "'Cooper Hewitt'",
      whiteSpace: "pre",
      shapeInside: "url(#rect417)",
      display: "inline",
      fill: "#000000",
      stroke: "#d52941",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "14.8167px",
      fontFamily: "'Cooper Hewitt'",
      InkscapeFontSpecification: "'Cooper Hewitt'",
      fill: "#6f1a07",
      fillOpacity: 1,
      stroke: "#d52941",
      strokeWidth: 0
    },
    x: 16.56068,
    y: 69.588524,
    id: "text7430"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan7428",
    style: {
      fill: "#6f1a07",
      fillOpacity: 1,
      strokeWidth: 0
    },
    x: 16.56068,
    y: 69.588524
  }, "ZEPHYR TRADE"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ee84ae6135f2fd9b649c0ef1ea3b22cb.svg";
export { ForwardRef as ReactComponent };